import { defineAction } from '~/prix'
import { z } from 'zod'
import expression from '~/prix/types/expression'
import { enumerated } from '~/prix/types/enumerated'
import veterinarySymptomListAction from './veterinarySymptomList.action.json' with { type: 'json' }
import { veterinarySymptomObject } from '../veterinarySymptomObject'

export const veterinarySymptomExpression = expression(veterinarySymptomObject.shape)

const veterinarySymptomListDefinition = defineAction({
  ...veterinarySymptomListAction,

  input: z.object({
    filter: veterinarySymptomExpression.nullish(),
    limit: z.number().min(1).max(5000).nullish(),
    offset: z.number().nullish(),
    orderBy: enumerated({
      createdAt: 'Data de criação',
      updatedAt: 'Data de atualização',
      id: 'Identificador',
      title: 'Titulo',
    }).nullish(),
    order: enumerated({
      ascending: 'Ascendente',
      descending: 'Descendente',
    }).nullish(),
    includeDeleted: z.boolean().nullish(),
  }),
  output: z.object({
    items: z.array(veterinarySymptomObject),
    count: z.number(),
  }),
})

export default veterinarySymptomListDefinition
